import {Router} from '@angular/router';

import {OidcService} from '../services/oidc.service';
import {ActiveUserService} from "../services/active-user.service";
import {concatMap, map, of} from "rxjs";
import {catchError} from "rxjs/operators";
import {GameService} from "../services/game.service";
import {inject} from "@angular/core";

export const UserIsAdminGuard = () => {
  const oidcService: OidcService = inject(OidcService);
  const activeUserService: ActiveUserService = inject(ActiveUserService);
  const gameService: GameService = inject(GameService);
  const router: Router = inject(Router);

  const is_authenticated = oidcService.isAuthenticated();
  if (!is_authenticated) {
    return router.navigateByUrl('auth/login');
  }

  const adminId = oidcService.getAdminIdFromClaims();
  if (adminId) {
    return activeUserService.retrieveActiveUser(adminId)
      .pipe(
        concatMap((adminP) => {
          // admin is found if admin is truthy (not null in this context)
          let adminFound = !!adminP;

          if (!adminFound) {
            return of(false);
          }
          // if the admin is found, go get their games
          return gameService.getGamesForUser(adminId).pipe(map(() => adminFound));
        }),
        catchError(() => {
          return router.navigateByUrl('not-admin');
        }))
  }

  return router.navigateByUrl('not-admin');
}
